import type { ReactNode } from 'react';

/**
 * One outcome on /pago, said once: a glyph, a title, what it means, and the
 * way on. Shared by the payment results and Stripe's card confirmation.
 */

export type PagoResultGlyph = 'check' | 'clock' | 'info';

export function ResultPanel({ glyph, title, children, actions }: { glyph: PagoResultGlyph; title: string; children: ReactNode; actions: ReactNode }) {
  return (
    <section className="pago-result" aria-labelledby="pago-result-title">
      <span className="pago-result-glyph" data-glyph={glyph} aria-hidden="true">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          {glyph === 'check' ? <path d="M5 12.5l4.5 4.5L19 7.5" /> : null}
          {glyph === 'clock' ? (
            <>
              <circle cx="12" cy="12" r="8.5" />
              <path d="M12 7.5V12l3 2" />
            </>
          ) : null}
          {glyph === 'info' ? (
            <>
              <circle cx="12" cy="12" r="8.5" />
              <path d="M12 11v5M12 8h.01" />
            </>
          ) : null}
        </svg>
      </span>
      <h1 id="pago-result-title">{title}</h1>
      {children}
      <div className="pago-result-actions">{actions}</div>
    </section>
  );
}
